import React from 'react'
import {Box, SxProps, Theme, Tooltip} from '@mui/material'
import TaskAltIcon from '@mui/icons-material/TaskAlt'
import PendingActionsIcon from '@mui/icons-material/PendingActions'
import {SEMANTIC} from 'src/theme-new/tokens'
import {getActivityAckTooltip, isActivityAcknowledged} from 'src/components-new/feedback/activityAckUtils'

interface ActivityAckIconProps {
  activity: Record<string, any>
  size?: number
  sx?: SxProps<Theme>
}

/** "Presa visione" status icon: confirmed (success) or still to be confirmed (warning), detail on hover. */
export default function ActivityAckIcon({activity, size = 20, sx}: ActivityAckIconProps): JSX.Element {
  const confirmed = isActivityAcknowledged(activity)
  const Icon = confirmed ? TaskAltIcon : PendingActionsIcon
  const tooltip = getActivityAckTooltip(activity)

  return (
    <Tooltip title={tooltip} arrow>
      <Box
        component="span"
        aria-label={tooltip}
        data-testid={confirmed ? 'activity-ack-confirmed' : 'activity-ack-pending'}
        sx={{display: 'inline-flex', alignItems: 'center', flexShrink: 0, ...sx}}
      >
        <Icon sx={{fontSize: size, color: confirmed ? SEMANTIC.success.main : SEMANTIC.warning.main}} />
      </Box>
    </Tooltip>
  )
}
